// sol/SolApp.js
import React from "react";
import SolWrapper from "./SolWrapper";
import Design from "./Design";



export default function SolApp() {
  return (
    <SolWrapper>
      <div>
       <Design/>
       
       
      </div>
    </SolWrapper>
  );
}
